// extracted by mini-css-extract-plugin
export default {"wrapper":"InputDefault_wrapper__K+XuP"};